<div class="mb-2">
  <span class="secondary-details mb-2">{{ 'configuration.importerTaxSetting.importerTaxSetting' | translate }}</span>
</div>

<div [formGroup]="importerTaxSetting">
  <div formArrayName="data">
    <ng-container>
      <table aria-describedby="Importer-table" mat-table [dataSource]="ImporterDataSource">
        <ng-container matColumnDef="number">
          <th id="number" mat-header-cell *matHeaderCellDef>{{ 'configuration.importerTaxSetting.number' | translate }}</th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="importerRegistrationType">
          <th
            class="required-field"
            id="importerRegistrationType"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'configuration.importerTaxSetting.selectCountry' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              [ngStyle]="{
                'border-color': getImporterFormControlId(i, 'importerRegistrationType').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              formControlName="importerRegistrationType">
              <option value="">{{ 'configuration.importerTaxSetting.selectRegistrationType' | translate }}</option>
              <option
                *ngFor="let eachType of importerRegistraionTypes | dataPropertyGetter"
                [value]="eachType.key">
                {{ eachType.key }}, {{ eachType.value }}
              </option>
            </select>
          </td>
        </ng-container>

        <ng-container matColumnDef="importerRegistrationNumber">
          <th
            class="required-field"
            id="importerRegistrationNumber"
            mat-header-cell
            *matHeaderCellDef>
            {{ 'configuration.importerTaxSetting.importerRegistrationNumber' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <input
              [ngStyle]="{
                'border-color': getImporterFormControlId(i, 'importerRegistrationNumber').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              type="text"
              formControlName="importerRegistrationNumber" />
          </td>
        </ng-container>

        <ng-container matColumnDef="importerIssuingCountryCode">
          <th class="required-field" id="packageLength" mat-header-cell *matHeaderCellDef>
            {{ 'configuration.importerTaxSetting.importerIssuingCountryCode' | translate }}
          </th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroup]="row">
            <select
              [ngStyle]="{
                'border-color': getImporterFormControlId(i, 'importerIssuingCountryCode').errors
                  ? 'red'
                  : 'grey'
              }"
              class="form-control"
              formControlName="importerIssuingCountryCode">
              <option value="">{{ 'configuration.importerTaxSetting.selectCountry' | translate }}</option>
              <option *ngFor="let eachListVal of list" [value]="eachListVal.code">
                {{ eachListVal.name }}
              </option>
            </select>
          </td>
        </ng-container>

        <ng-container matColumnDef="Action">
          <th id="action" mat-header-cell *matHeaderCellDef>{{ 'global.action' | translate }}</th>
          <td mat-cell *matCellDef="let row; let i = index">
            <button
              (click)="DeleteImporterItem(pieces, i)"
              class="ml-2 secondary-btn"
              type="button">
              {{ 'global.delete' | translate }}
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns"></tr>

        <tr class="mat-row justify-content-center" *matNoDataRow>
          {{ 'global.noDataAvailable' | translate }}
        </tr>
      </table>
    </ng-container>
  </div>
  <div class="col-12 text-end">
    <button (click)="AddNewImporterItem()" class="secondary-btn" type="button">{{ 'global.addRow' | translate }}</button>
    <button
      [disabled]="!(this.importerTaxSetting.valid && isValueChanged)"
      (click)="saveImporterConfig()"
      class="ml-1 primary-btn"
      type="button">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
